import { FormAttribute } from '@/shared/forms/form-attribute.decorator'
import { email, minLength, required, sameAs } from 'vuelidate/lib/validators'
import { noop } from '@/shared/utils/noop'

export class RegistrationForm {
  @FormAttribute({
    validators: {
      email,
      required,
    },
  })
  public email!: string

  @FormAttribute({
    validators: {
      required,
    },
  })
  public organisation!: string

  @FormAttribute({
    validators: {
      minLength: minLength(8),
      required,
    },
  })
  public password!: string

  @FormAttribute({
    deserialize: noop,
    serialize: noop,
    validators: {
      sameAs: sameAs('password'),
    },
  })
  public passwordConfirmation!: string
}
